import axios from "axios";
const ServerAxios = axios.create({
  baseURL: window.location.origin,
  withCredentials: true,
});

export default ServerAxios;
